import { rankingData } from '@/mocks/homeData';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 text-xs font-medium bg-primary-100 text-primary-700 rounded-full mb-4 whitespace-nowrap">
            热门榜单
          </span>
          <h2 className="text-xl md:text-3xl font-bold text-foreground-950 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
            人气漫画排行榜
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">实时更新最受读者欢迎的漫画作品，看看大家都在追什么</p>
        </div>

        <div className="space-y-3">
          {rankingData.map((item, i) => (
            <div
              key={i}
              className="flex items-center gap-3 md:gap-5 p-3 md:p-4 bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-200 transition-colors cursor-pointer"
            >
              <div className="w-8 md:w-10 h-8 md:h-10 flex items-center justify-center flex-shrink-0">
                {i === 0 ? (
                  <span className="w-7 h-7 rounded-full bg-primary-500 flex items-center justify-center">
                    <i className="ri-vip-crown-fill text-white text-sm"></i>
                  </span>
                ) : i === 1 ? (
                  <span className="w-7 h-7 rounded-full bg-secondary-400 flex items-center justify-center">
                    <i className="ri-medal-fill text-white text-sm"></i>
                  </span>
                ) : i === 2 ? (
                  <span className="w-7 h-7 rounded-full bg-accent-400 flex items-center justify-center">
                    <i className="ri-medal-fill text-white text-sm"></i>
                  </span>
                ) : (
                  <span className="text-base md:text-lg font-bold text-foreground-400 w-7 h-7 flex items-center justify-center">
                    {i + 1}
                  </span>
                )}
              </div>

              <div className="flex-shrink-0 w-12 md:w-14 h-16 md:h-[72px] rounded-md overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover"
                />
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 truncate">{item.title}</h3>
                  {item.isNew && <span className="px-1.5 py-0.5 text-[10px] font-medium bg-accent-100 text-accent-700 rounded whitespace-nowrap">新</span>}
                  {item.isHot && <span className="px-1.5 py-0.5 text-[10px] font-medium bg-primary-100 text-primary-700 rounded whitespace-nowrap">热</span>}
                </div>
                <div className="flex items-center gap-3 mt-1 text-xs text-foreground-500">
                  <span className="whitespace-nowrap">{item.author}</span>
                  <span className="text-foreground-300">|</span>
                  <span className="whitespace-nowrap">{item.genre}</span>
                </div>
              </div>

              <div className="flex-shrink-0 text-right">
                <div className="text-sm md:text-base font-semibold text-primary-600 whitespace-nowrap">{item.views}</div>
                <div className="text-[10px] md:text-xs text-foreground-400 whitespace-nowrap">阅读量</div>
              </div>

              <div className="flex-shrink-0 hidden sm:block">
                <span className="inline-flex items-center gap-1 px-3 py-1.5 text-xs font-medium bg-foreground-900 text-white rounded-md hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer">
                  立即阅读
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}